export default __webpack_public_path__ + "static/media/Bandeau 13.6f95bb11.jpg";